import H5 from '@base/H5/H5';
import styled from '@emotion/styled';
import TooltipClose from '@icon/Planner/TooltipClose';
import { Spacings } from '@styles/index';

const TooltipWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding: ${Spacings.SPACING_4B};
`;

const StyledH5 = styled(H5)`
  color: var(--color-text-tertiary);
`;

const TooltipIconWrapper = styled.div`
  width: ${Spacings.SPACING_4B};
  height: ${Spacings.SPACING_4B};
  margin-block-start: ${Spacings.SPACING_6};
  cursor: pointer;
`;

const EditCoursePlanTooltip = ({ onClose }) => {
  return (
    <TooltipWrapper>
      <StyledH5>
        Here you can edit or remove this course from your planner
      </StyledH5>
      <TooltipIconWrapper>
        <TooltipClose
          size="16px"
          onClick={onClose}
          color="var(--color-text-tertiary)"
        />
      </TooltipIconWrapper>
    </TooltipWrapper>
  );
};

export default EditCoursePlanTooltip;
